import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	access_token: '',
    permissions: [],
    user:{},
  },
  getters: {
    get_access_token: (state) => state.access_token,
    get_user:(state) =>state.user,
  },
  mutations: {
  	storeAccessToken(state, access_token) {
  		state.access_token = access_token;
  	},
    removeAccessToken(state) {
      state.access_token = '';
    },
    storeUser(state,user) {
      state.user = user;
    },
    removeUser(state) {
      state.user = {};
    },
  },
  actions: {
  	storeAccessToken({commit}, access_token) {
  		return new Promise((resolve, reject) => {
	      	commit('storeAccessToken', access_token);
	      	resolve();
	    });
  	},
    removeAccessToken({commit}) {
      return new Promise((resolve, reject) => {
          commit('removeAccessToken');
          resolve();
      });
    },
    storeUser({commit}, user) {
      return new Promise((resolve, reject) => {
          commit('storeUser', user);
          resolve();
      });
    },
    removeUser({commit}) {
      return new Promise((resolve, reject) => {
          commit('removeUser');
          resolve();
      });
    },
  },
  modules: {
  }
})
